<template>
    <div>
      <modal name="payment" @opened="onOpened" @closed="onClosed">
        <div class="modal_content payment_modal full_gray dark_modal">
          <div class="dark_header" @click="$modal.hide('payment')">
            <img
              src="https://space.monresto.menu/new_images/orange_left_arrow.png"
              alt=""
              srcset=""
            />
          </div>
  
          <div class="full full_gray center paymement_buttons_full">
            <div class="split_message">
              <div class="split_message_text">
                <span>Mode de</span>
                <span class="orange_circle"></span>
                <span class="orange_circle"></span>
              </div>
              <div class="split_message_text1">
                <span>paiement</span>
                <span class="orange_circle"></span>
                <span class="orange_circle"></span>
              </div>
            </div>
            <p class="payment_text">
              Veuillez sélectionner votre mode de paiement préféré
            </p>
  
            <!-- <div class="payment_modes">
              <div @click="active_payment=0" :class="`payment_mode ${active_payment==0?'active':''}`">
                <span>Espece</span>
                <img src="https://space.monresto.menu/new_images/payment/cash.png" alt="" srcset="">
              </div>
              <div @click="active_payment=1" :class="`payment_mode ${active_payment==1?'active':''}`">
                <span>Carte </span>
                <img src="https://space.monresto.menu/new_images/payment/card.png" alt="" srcset="">
              </div>
  
              <div @click="()=>{active_payment=2;moneticoPayment()}" :class="`payment_mode ${active_payment==2?'active':''}  origin`">
                <span>Monetico</span>
                <img src="https://space.monresto.menu/new_images/payment/monetico.png" alt="" srcset="">
              </div>
  
              <div @click="active_payment=3" :class="`payment_mode ${active_payment==3?'active':''}`">
                <span>Bitcoin</span>
                <img src="https://space.monresto.menu/new_images/payment/bitcoin.png" alt="" srcset="">
              </div>
  
              <div @click="active_payment=4" :class="`payment_mode ${active_payment==4?'active':''}`">
                <span>Paypal</span>
                <img src="https://space.monresto.menu/new_images/payment/paypal.png" alt="" srcset="">
              </div>
  
              <div @click="active_payment=5" :class="`payment_mode ${active_payment==5?'active':''}`">
                <span>Google pay</span>
                <img src="https://space.monresto.menu/new_images/payment/google.png" alt="" srcset="">
              </div>
  
              <div @click="active_payment=6" :class="`payment_mode ${active_payment==6?'active':''}`">
                <span>Apple pay</span>
                <img src="https://space.monresto.menu/new_images/payment/apple.png" alt="" srcset="">
              </div>
  
            </div> -->
            <div class="payement_buttons_container">
              <div class="payement_buttons">
                <div
                  @click="paiment_mode = 1"
                  :class="`payment_button ${paiment_mode == 1 ? 'active' : ''}`"
                >
                  <img
                    src="https://space.monresto.menu/new_images/payment/card.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div
                  @click="paiment_mode = 2"
                  :class="`payment_button ${paiment_mode == 2 ? 'active' : ''}`"
                >
                  <img
                    src="https://space.monresto.menu/new_images/payment/apple.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div
                  @click="paiment_mode = 3"
                  :class="`payment_button ${paiment_mode == 3 ? 'active' : ''}`"
                >
                  <img
                    src="https://space.monresto.menu/new_images/payment/google.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div
                  @click="paiment_mode = 4"
                  :class="`payment_button ${paiment_mode == 4 ? 'active' : ''}`"
                >
                  <img
                    src="https://space.monresto.menu/new_images/payment/paypal.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <!-- <div @click="paiment_mode=5" :class="`payment_button  ${paiment_mode==5?'active':''}`">
              <img src="https://space.monresto.menu/new_images/payment/clicandpay.png" class="clicandpay" alt="" srcset="">
            </div> -->

              <!-- <div class="paymement_button cash" @click="sendOrder(1)">
                
                <span>Espèce</span>
                <img src="https://space.monresto.menu/new_images/payment/cash.png" alt="" srcset="">
              </div>
             
              <div
                class="paymement_button card_monetico"
                @click="moneticoPayment()"
              >
                <span>Monetico</span>
                
                <img src="https://space.monresto.menu/new_images/payment/monetico.png" alt="" srcset="">
              </div>
              <div class="paymement_button bitcoin_card">
               
                <span>Bitcoin</span>
                <img src="https://space.monresto.menu/new_images/payment/bitcoin.png" alt="" srcset="">
              </div>
              <div class="paymement_button " @click="moneticoPayment()">
                <span>Carte bancaire</span>
                
                <img src="https://space.monresto.menu/new_images/payment/card.png" alt="" srcset="">
              </div>
              <div class="paymement_button " @click="initStripe()">
                <span>Stripe</span>
                
                <img src="https://space.monresto.menu/new_images/payment/card.png" alt="" srcset="">
              </div>
              <div class="paymement_button google_pay">
                <GooglePayButton
                  id="google-pay-btn"
                  :options="options"
                  @payed="processPayment($event)"
                  @cancel="handleCancel"
                />
              </div>
              
              <form id="payment-form" v-show="showStripe">
                <div id="card-element">
                </div>
                <button id="submit">
                  <div class="spinner hidden" id="spinner"></div>
                  <span id="button-text">Pay now</span>
                </button>
                <p id="card-error" role="alert"></p>
                <p class="result-message hidden">
                  Payment succeeded, see the result in your
                  <a href="" target="_blank">Stripe dashboard.</a> Refresh the
                  page to pay again.
                </p>
              </form>
              <div class="paymement_button card paypal_button">
                <img
                  src="https://space.monresto.menu/paypal.svg"
                  alt=""
                  class="paypal_payment_icon"
                />
                <PayPal
                  :amount="total"
                  :currency="currentCurrency.currency_code"
                  :client="paypal"
                  :button-style="aStyle"
                  env="sandbox"
                  @payment-authorized="authorized"
                  @payment-completed="completed"
                  @payment-cancelled="cancelled"
                >
                </PayPal>
              </div> -->
            </div>
          </div>
          <div class="payment_content">

            <p v-if="paiment_mode == 1">Payer par carte</p>
            <div v-if="paiment_mode == 1 && modes.monetico" @click="moneticoPayment()" class="payment_content_button">
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>

            <div v-if="paiment_mode == 1 && modes.stripe" @click="initStripe()" class="payment_content_button">
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>

            <form id="payment-form" v-show="paiment_mode == 1 && modes.stripe && showStripe">
              <div id="card-element"></div>
              <button id="submit">
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">Pay now</span>
              </button>
              <p id="card-error" role="alert"></p>
              <p class="result-message hidden">
                Payment succeeded, see the result in your
                <a href="" target="_blank">Stripe dashboard.</a> Refresh the
                page to pay again.
              </p>
            </form>

            <p v-if="paiment_mode == 2">Payer par Apple Pay</p>
            <!-- <div v-if="paiment_mode==2" class="payment_content_button">
                <span>Payer par Apple Pay </span>
                <img src="https://space.monresto.menu/new_images/payment/apple.png" alt="" srcset="">
              </div> -->
            <template v-if="paiment_mode == 2">
              <apple-pay-button @click="applePay" buttonstyle="black" type="plain" locale="en"></apple-pay-button>
            </template>
            <p v-if="paiment_mode == 3">Payer par Google Pay</p>
            <!-- <div v-if="paiment_mode==3" class="payment_content_button">
                <span>Payer par Google Pay </span>
                <img src="https://space.monresto.menu/new_images/payment/google.png" alt="" srcset="">
              </div> -->
            <template v-if="paiment_mode == 3">
              <GooglePayButton id="google-pay-btn" :options="options" @payed="processPayment($event)"
                @cancel="handleCancel" />
            </template>

            <p v-if="paiment_mode == 4">Payer par Paypal</p>

            <!-- <div v-if="paiment_mode==4" @click="initClicAndPay" class="payment_content_button">
                <span>Payer par Paypal </span>
                <img src="https://space.monresto.menu/new_images/payment/paypal.png" alt="" srcset="">
                
              </div>  -->
  
              <template v-if="paiment_mode == 4">
                <PayPal
                  :amount="total"
                  :currency="currentCurrency.currency_code"
                  :client="paypal"
                  :button-style="aStyle"
                  env="sandbox"
                  @payment-authorized="authorized"
                  @payment-completed="completed"
                  @payment-cancelled="cancelled"
                  :braintree="braintreeSdk"
                ></PayPal>
              </template>
  
              <div
                v-if="paiment_mode == 1 && modes.clicandpay"
                @click="initClicAndPay"
                class="payment_content_button"
              >
                <span>Payer par Click&Pay </span>
                <img
                  src="https://space.monresto.menu/new_images/payment/clicandpay.png"
                  class="clicandpay"
                  alt=""
                  srcset=""
                />
              </div>
  
              <div
                v-if="clicToken"
                class="kr-embedded"
                kr-popin
                :kr-form-token="clicToken"
              >
                <!-- payment form fields -->
                <div class="kr-pan"></div>
                <div class="kr-expiry"></div>
                <div class="kr-security-code"></div>
  
                <!-- payment form submit button -->
                <button class="kr-payment-button"></button>
  
                <!-- error zone -->
                <div class="kr-form-error"></div>
              </div>
              <!-- <div :class="`kr_payment ${paiment_mode==5?'visible':''}`">
                <div   class="kr-embedded" 
                  kr-form-token="DEMO-TOKEN-TO-BE-REPLACED">
  
                    <div class="kr-pan"></div>
                    <div class="kr-expiry"></div>
                    <div class="kr-security-code"></div>
  
                    <button class="kr-payment-button"></button>
  
                    <div class="kr-form-error"></div>
                </div>
              </div> -->

            <!-- <div class="confirm_send">
                <span>M’envoyer une facture par email</span>
              </div> -->


            <div class="order_infos">

              <div class="order_infos_line">
                <span>Total<span class="orange_point"></span></span>
                <span>{{ total * 1 + pourboir * 1
                }}{{ currentCurrency.symbol }}</span>
              </div>
            </div>
          </div>
          <div class="loader">
            <div class="loader_container">
              <div class="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>

          <div class="payment_container">
            <form method="post" id="payment_form" ref="payment_form"
              action="https://p.monetico-services.com/test/paiement.cgi">
              <input type="hidden" id="TPE" name="TPE" :value="restaurant && restaurant.configurationPaiment
                ? restaurant.configurationPaiment.tpe
                : ''
                " />
              <input type="hidden" id="societe" name="societe" :value="restaurant && restaurant.configurationPaiment
                ? restaurant.configurationPaiment.societe
                : ''
                " />
              <input type="hidden" id="lgue" name="lgue" value="FR" />
              <input type="hidden" id="version" name="version" value="3.0" />
              <input type="hidden" id="reference" name="reference" :value="config.ref" />
              <input type="hidden" id="date" name="date" :value="config.date" />
              <input type="hidden" id="montant" name="montant" :value="config.price" />
              <input type="hidden" id="contexte_commande" name="contexte_commande" :value="config.context" />
              <input type="hidden" id="libre" name="texte-libre" :value="config.desc" />
              <input type="hidden" id="MAC" name="MAC" :value="config.MAC" />
              <input type="hidden" id="url_retour_ok" name="url_retour_ok" :value="config.url_retour_ok" />
              <input type="hidden" id="url_retour_err" name="url_retour_err" :value="config.url_retour_err" />
            </form>
          </div>
        </div>
        <!-- <div class="modal-footer  bottom_commande_cart">
           
            <div id="payemnt_back" @click="$modal.hide('payment')">
              <span class="caret-left"><i class="fas fa-chevron-left"></i></span>
              <div class="button_commander">Retour</div>
            </div>
          </div> -->
        </div>
      </modal>
  
     
  
      <modal name="success" @opened="onOpened" @closed="onClosed">
        <div class="modal_content full_gray dark_modal">
          <div class="full full_gray">
            <div class="success_messsages">
              <div class="success_message_text">
                <div class="orange_circle"></div>
                <span>Paiement</span>
              </div>
              <div class="success_message_text1">
                <div class="orange_circle"></div>
                <div class="orange_circle"></div>
                <div class="orange_circle"></div>
                <span>effectue!</span>
              </div>
            </div>
            <div class="success_message">
              <p>
                Nous vous remercions pour votre réservation. a bientôt !
              </p>
              <p class="light_message">
                Une confirmation a été envoyé à votre adresse email
              </p>
              
            </div>
          </div>
          <div class="modal-footer full_modal_footer modal_buttons">
           
          </div>
        </div>
      </modal>
  
      <modal name="error" @opened="onOpened" @closed="onClosed">
        <span class="close_modal close_modal_cart" @click="$modal.hide('error')">
          <div>
            <i class="fas fa-chevron-left"></i>
          </div>
        </span>
        <div class="modal_title cart_header">
          <span>Probleme</span>
        </div>
        <div class="modal_content full_gray">
          <div class="full full_gray">
            <div class="success_message">
              <img
                src="https://space.monresto.menu/azour/img/error.png"
                alt=""
                srcset=""
                class="error_img"
              />
              <p
                style="padding: 0px 24px"
                v-if="error_message.includes('Désolé,')"
                v-html="error_message"
              ></p>
              <p v-else>
                Vous pouvez avoir un problème avec le processus de commande <br />
                Merci d'essayer plus tard
              </p>
            </div>
          </div>
          <div class="modal-footer modal_buttons">
            <div
              id="success_back"
              @click="$modal.hide('error')"
              class="modal_button"
            >
              <div class="modal_button_text">Retour</div>
            </div>
          </div>
        </div>
      </modal>
      <modal name="error_payment" @opened="onOpened" @closed="onClosed">
        <span
          class="close_modal close_modal_cart"
          @click="$modal.hide('error_payment')"
        >
          <div>
            <i class="fas fa-chevron-left"></i>
          </div>
        </span>
        <div class="modal_title cart_header">
          <span>Probleme</span>
        </div>
        <div class="modal_content full_gray">
          <div class="full full_gray">
            <div class="success_message">
              <img
                src="https://space.monresto.menu/azour/img/error.png"
                alt=""
                srcset=""
                class="error_img"
              />
              <p>
                Votre paiement n'est pas terminé <br />
                Veuillez réessayer
              </p>
            </div>
          </div>
          <div class="modal-footer modal_buttons">
            <div
              id="success_back"
              @click="$modal.hide('error_payment')"
              class="modal_button"
            >
              <div class="modal_button_text">Retour</div>
            </div>
          </div>
        </div>
      </modal>
  
      <modal name="loading" @opened="onOpened" @closed="onClosed">
        <div class="modal_content full_gray dark_modal prepaiment loader_modal">
          <div class="full full_gray">
            <div class="pending_message success_message">
              <!-- <img
                src="https://space.monresto.menu/azour/img/loading.gif"
                alt=""
                srcset=""
                class="loading_img"
              /> -->
            <!-- <p>
                S'il vous plaît soyez patient <br />
                votre demande est encour de traitement
              </p> -->

            <div class="pending_title">
              <div class="success_message_text">
                <div class="orange_circle"></div>
                <span>Operation</span>
              </div>
              <div class="success_message_text1">
                <div class="orange_circle"></div>
                <div class="orange_circle"></div>
                <div class="orange_circle"></div>
                <span>en cours</span>
              </div>
            </div>

            <div class="loader_container">
              <p class="prepaiment_title">
                Veuillez patienter votre opération sera bientôt terminée !
              </p>
              <div class="loader_animation">
                <div class="loader_line">
                  <div class="loader_line1"></div>
                </div>
                <div class="loader_circle"></div>
                <div class="loader_circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>
  
  <script>
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import PayPal from "vue-paypal-checkout";
  import Axios from "axios";
  import "vue-swipe-actions/dist/vue-swipe-actions.css";
  import "./orders/style.css";
  import GoogleLogin from "vue-google-login";
  import VFacebookLogin from "vue-facebook-login-component";
  import GooglePayButton from "vue-google-pay";
  import moment from "moment";
  export default {
    components: {
      PayPal,
      GoogleLogin,
      VFacebookLogin,
      GooglePayButton: GooglePayButton,
    },
    data() {
      return {
       restaurant:{},
        currentCurrency:{
          symbol : "€"
        },
        image:"",
        signaturePad:null,
        operaReservation:null,
        showPinError: false,
        pin: "",
        showOperaError: false,
        operaRef: "19215692",
        res_to_download: null,
        pourboir: 0,
        showOther: false,
        paiment_mode: 2,
        reference_payment: null,
        active_payment: 0,
        splitEqual: false,
        stars: 0,
        covers: 1,
        options: {
          environment: "TEST",
          buttonColor: "white",
          allowedCardNetworks: [
            "AMEX",
            "DISCOVER",
            "INTERAC",
            "JCB",
            "MASTERCARD",
            "VISA",
          ],
          allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          merchantInfo: {
            // merchantName: this.restaurant.googlepay.merchantName,
            // merchantId: this.restaurant.googlepay.merchantId,
            merchantName: "Ihospitality",
            merchantId: "BCR2DN4TZCGNJMLG",
          },
          transactionInfo: {
            totalPriceStatus: "FINAL",
            totalPrice: "1.00",
            currencyCode: "EUR",
            countryCode: "FR",
          },
        },
        FB: {},
        facebook: {},
        params1: {
          client_id:
            "592182686828-tu4qq08ir4h83bo67hpo105um1fhhp77.apps.googleusercontent.com",
        },
        // only needed if you want to render the button with the google ui
        renderParams: {
          width: 250,
          height: 50,
          longtitle: true,
        },
        values: [],
        showAll: false,
        showStripe: false,
        cart_button_text: "Commander",
        stripe: {},
        client_form: {},
        config: {
          MAC: "",
          url_retour_ok: "",
          url_retour_err: "",
          price: "",
          currentDate: "",
          context: "",
          desc: "",
          ref: "",
        },
        data: [11, 2, 3, 4, 5],
        restau: {
          configurationPaiment: {},
        },
        aStyle: {
          label: "checkout",
          size: "large",
          color: "gold",
          // shape: 'rect',
          // color: 'black',
        },
        params: {},
        paypal_paiement: null,
        braintreeSdk: window.braintre,
  
        clicToken: null,
  
         reservation:{},
      };
    },
    watch: {
     
     
      payement_config: function (newVal) {
        if (newVal) {
          console.log(
            "payement_configpayement_configpayement_configpayement_config"
          );
          console.log(newVal);
          this.config = Object.assign({}, { ...newVal });
          setTimeout(() => {
            this.$refs.payment_form.submit();
          }, 500);
        }
      },
    
      
    },
    computed: {
      ...mapGetters([
        "client_reservation",
        "client",
        "configuration",
        "player_id",
        "order",
        "old_order",
        "isloadingOrder",
        "payement_config",
        "error_message",
        "menus",
      ]),
      
      paypal() {
        if (this.restaurant.modes) {
          if (this.restaurant.modes.paypal) {
            return {
              sandbox: this.restaurant.paypal.sandbox,
              production: this.restaurant.paypal.production,
            };
          }
        }
        return {
          sandbox: "",
          production: "",
        };
      },
  
      
      modes() {
        if (this.restaurant && this.restaurant.modes) {
          return this.restaurant.modes;
        }
        return {};
      },
  
     
      total: function () {
        let total = 15;
        
        const urlParams = new URLSearchParams(window.location.search);
  
    
        if(urlParams.get('valprep')){
            total = urlParams.get('valprep')*1
        }
        return total.toFixed(2);
      },
    },
    sockets: {
      connect: function () {
        console.log("socket connected");
      },
      checkTableResult:function(data){
        // console.log(data);
  
        // this.$modal.hide("splash");
        // if(data && data.data){
        //   // this.commitCheckTable(data);
  
        //   this.res_to_download = data.data[data.data.length-1]
        // // alert("yes")
        // }
        
  
        // console.log("checkTablePos")
      },
  
      
    },
    methods: {
      
      async initClicAndPay() {
        let $this = this;
        if (!$this.reference_payment) {
          let rslt = await this.sendOrder(null, true);
        }
        // let token = this.restaurant.clicandpay.token
        let res = await Axios.post(
          "https://space.monresto.menu/api/v1/web/clicandpay",
          {
            amount: this.total * 1 + this.pourboir * 1,
            currency:"EUR",
            orderId: $this.reference_payment,
            customer: {
              email: this.client_form.email
                ? client_form.email
                : "tfkizim@gmail.com",
            },
            Authorization:
            // `Basic ${token}`,
              "Basic MzM2NTkxNjU6dGVzdHBhc3N3b3JkXzFnNkI4QUJ4a3hrUWJ5dWMxYWZzR3RBakFseFFBZU5PekUxZDVjQnU4MkZmMw==",
          },
          {}
        )
          .then(function (result) {
            return result.data;
          })
          .then(function (result) {
            return result.body;
          })
          .catch((err) => {
            console.log({ err });
          });
        // .then(function(data) {
        //   return data
        // })
        this.clicToken = res.answer.formToken;
  
        var my_awesome_script = document.createElement("script");
  
        let prams = window.location.href.split("?")[0].split("/");
        let pas = 0;
        let table = null;
      
        let restaurant_ = prams[prams.length - (pas + 1)];
        let return_url = `https://space.monresto.menu/${restaurant_}?ref=${$this.reference_payment}1`;
        if (table) {
          return_url = `https://space.monresto.menu/${restaurant_}/${table}?ref=${$this.reference_payment}1`;
        }
  
        my_awesome_script.setAttribute(
          "src",
          "https://api-clicandpay.groupecdn.fr/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js"
        );
        my_awesome_script.setAttribute(
          "kr-public-key",
          "33659165:testpublickey_udUn5ozc6NwSbM3r479WfIJQkot5O1gWabElhClL3MJNY"
        );
        my_awesome_script.setAttribute("kr-get-url-success", return_url);
  
        document.head.appendChild(my_awesome_script);
  
        console.log({ res });
      },
      applePay() {
        // var request = {
        //     version:3,
        //     countryCode: 'FR',
        //     merchantIdentifier: 'merchant.devmonresto',
        //     currencyCode:"EUR",
        //     supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
        //     merchantCapabilities: ['supports3DS'],
        //     total: { label: 'Monresto.menu', amount: `${this.total}` },
        // }
        // var session = new   ApplePaySession(3, request);
        // console.log(session)
  
        // if (!ApplePaySession) {
        //     return;
        // }
  
        // Define ApplePayPaymentRequest
        const request = {
          countryCode: "FR",
          currencyCode:"EUR",
          merchantCapabilities: [
            "supports3DS",
            "supportsCredit",
            "supportsDebit",
          ],
          supportedNetworks: ["visa", "masterCard", "amex", "discover"],
          total: {
            label: "Monresto.menu",
            type: "final",
            amount: `${parseFloat(this.total * 1 ).toFixed(
              2
            )}`,
          },
        };
  
        // Create ApplePaySession
        const session = new ApplePaySession(3, request);
  
        session.onvalidatemerchant = async (event) => {
          // Call your own server to request a new merchant session.
          // let restaurant = this.$route.params.restaurant
          // let merchantSession = await this.validateMerchant(event.validationURL, restaurant);
          let merchantSession = await this.validateMerchant(event.validationURL);
          merchantSession = JSON.parse(merchantSession.data.body.body);
          console.log({ merchantSession });
          // alert("onvalidatemerchant")
          session.completeMerchantValidation(merchantSession);
  
          // const result = {
          //     "status": ApplePaySession.STATUS_SUCCESS
          // };
          // console.log(result);
          // session.completePayment(result);
        };
  
        session.onpaymentmethodselected = (event) => {
          // Define ApplePayPaymentMethodUpdate based on the selected payment method.
          // No updates or errors are needed, pass an empty object.
          // alert("onpaymentmethodselected")
          const update = {};
          session.completePaymentMethodSelection({
            newTotal: request.total,
            newLineItems: [],
          });
        };
  
        session.onshippingmethodselected = (event) => {
          // Define ApplePayShippingMethodUpdate based on the selected shipping method.
          // No updates or errors are needed, pass an empty object.
          // alert("onshippingmethodselected")
          const update = {};
          session.completeShippingMethodSelection(update);
        };
  
        session.onshippingcontactselected = (event) => {
          // Define ApplePayShippingContactUpdate based on the selected shipping contact.
          // alert("onshippingcontactselected")
          const update = {};
          session.completeShippingContactSelection(update);
        };
  
        session.onpaymentauthorized = (event) => {
          // Define ApplePayPaymentAuthorizationResult
          // alert("onpaymentauthorized")
          // alert(JSON.stringify(ApplePaySession));
          const result = {
            status: ApplePaySession.STATUS_SUCCESS,
          };
          // alert("onpaymentauthorized")
          session.completePayment(result);
          this.sendOrder();
        };
  
        session.oncancel = (event) => {
          // Payment cancelled by WebKit
        };
  
        session.begin();
      },
      // async validateMerchant(url, restaurant){
      async validateMerchant(url) {
      // return Axios.get(`https://space.monresto.menu/applePay/${restaurant}`);
        return Axios.get("https://space.monresto.menu/applePay");
        // return Axios.post("https://space.monresto.menu/applePay",{
        //     merchantIdentifier:"merchant.devmonresto",
        //     displayName:"Monresto",
        //     initiative:"web",
        //     initiativeContext:"space.monresto.menu"
        // })
      },
      processPayment(paymentData) {
        // process payment
        console.log(paymentData);
        this.sendOrder(3);
      },
      handleCancel() {
        // handle cancel event
      },
     
      
      
      onOpened() {
        window.scrollTo(0, 1);
        document.getElementsByTagName("html")[0].classList.add("modal-opened");
      },
      onClosed() {
        document.getElementsByTagName("html")[0].classList.remove("modal-opened");
      },
      
     
      
      
     
      async initStripe() {
        let $this = this;
        this.stripe = Stripe(this.restaurant.stripe.key);
        var elements = this.stripe.elements();
        var stripe = this.stripe;
        this.showStripe = true;
        document.getElementById("submit").disabled = true;
        if (!$this.reference_payment) {
          let rslt = await this.sendOrder(null, true);
        }
  
        fetch("https://space.monresto.menu/api/v1/web/create-payment-intent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ref: $this.reference_payment,
            reserved_items: [],
            total: this.total * this.pourboir,
            currency:"EUR",
          }),
        })
          .then(function (result) {
            return result.json();
          })
          .then(function (data) {
            var style = {
              base: {
                color: "#32325d",
                fontFamily: "Roboto, sans-serif",
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                  color: "#32325d",
                },
              },
              invalid: {
                fontFamily: "Roboto, sans-serif",
                color: "#fa755a",
                iconColor: "#fa755a",
              },
            };
            var card = elements.create("card", { style: style });
            // Stripe injects an iframe into the DOM
            card.mount("#card-element");
  
            card.on("change", function (event) {
              // Disable the Pay button if there are no card details in the Element
              document.querySelector("#submit").disabled = event.empty;
              document.querySelector("#card-error").textContent = event.error
                ? event.error.message
                : "";
            });
            var form = document.getElementById("payment-form");
            form.addEventListener("submit", function (event) {
              event.preventDefault();
              // Complete payment when the submit button is clicked
              payWithCard(stripe, card, data.clientSecret);
            });
            var payWithCard = function (stripe, card, clientSecret) {
              loading(true);
              stripe
                .confirmCardPayment(clientSecret, {
                  payment_method: {
                    card: card,
                  },
                })
                .then(function (result) {
                  console.log({ result });
                  if (result.error) {
                    // Show error to your customer
                    showError(result.error.message);
                  } else {
                    // The payment succeeded!
                    $this.getOrderbyRef({
                      ref: result.paymentIntent.description,
                      callback: (order) => {
                        console.log(order);
                        console.log("alksd;lasjljasldj;l");
  
                        $this.sendOrder(3);
  
                        // this.downloadFile(order);
                      },
                    });
  
                    orderComplete(result.paymentIntent.id);
                  }
                });
            };
            /* ------- UI helpers ------- */
            // Shows a success message when the payment is complete
            var orderComplete = function (paymentIntentId) {
              loading(false);
  
              console.log(paymentIntentId);
              document
                .querySelector(".result-message a")
                .setAttribute(
                  "href",
                  "https://dashboard.stripe.com/test/payments/" + paymentIntentId
                );
              document
                .querySelector(".result-message")
                .classList.remove("hidden");
              document.querySelector("button").disabled = true;
            };
            // Show the customer the error from Stripe if their card fails to charge
            var showError = function (errorMsgText) {
              loading(false);
              var errorMsg = document.querySelector("#card-error");
              errorMsg.textContent = errorMsgText;
              setTimeout(function () {
                errorMsg.textContent = "";
              }, 4000);
            };
            // Show a spinner on payment submission
            var loading = function (isLoading) {
              if (isLoading) {
                // Disable the button and show a spinner
                document.querySelector("button").disabled = true;
                document.querySelector("#spinner").classList.remove("hidden");
                document.querySelector("#button-text").classList.add("hidden");
              } else {
                document.querySelector("button").disabled = false;
                document.querySelector("#spinner").classList.add("hidden");
                document.querySelector("#button-text").classList.remove("hidden");
              }
            };
          });
      },
      ...mapActions([
        "addReservation",
        "updateStatusReservation",
        "getReservationByTable",
        "getConfiguration",
        "addClient",
        "checkClient",
        "checkTable",
        "sendBill",
        "downloadFile",
        "generateBill",
        "createOrder",
        "updateOrder",
        "getOrderbyRef",
        "getTablesDispos",
        "generatePaymentData",
        "isValidSignature",
        "commitCheckTable",
        "getOperaReservation"
      ]),
     
      authorized(param) {
        console.log("authorized");
        console.log(param);
      },
      completed(param) {
        console.log("completed");
        console.log(param);
        this.paypal_paiement = param;
        this.sendOrder(2);
      },
      cancelled(param) {
        console.log("cancelled");
        console.log(param);
      },
     
      async sendOrder(type_payement = null, is_payment = null) {
    
        this.$modal.show("loading");
  
        let prams = window.location.href.split("?")[0].split("/");
        let pas = 0;
        let table = null;
       
        let restaurant_ = prams[prams.length - (pas + 1)];
  
  
            const urlParams = new URLSearchParams(window.location.search);
  
    
          this.reservation = {
            nom:urlParams.get('nom'),
            email:urlParams.get('email'),
            prenom:urlParams.get('prenom'),
            phone:urlParams.get('phone'),
            date:urlParams.get('date'),
            time:urlParams.get('date')+" "+urlParams.get('heure'),
            adultes:urlParams.get('adultes'),
            comment:urlParams.get('detail'),
            table:urlParams.get('table'),
          }
  
         let newItem = {
          table: this.reservation.table,
          nom: this.reservation.nom,
          email: this.reservation.email,
          prenom: this.reservation.prenom,
          phone: this.reservation.phone,
          date: new Date(moment(urlParams.get('date')).format("YYYY-MM-DD")),
          heure: `${moment(urlParams.get('date')+" "+urlParams.get('heure')).format("HH:mm")}`,
          duree: "",
          package: urlParams.get('package'),
          enfants: this.reservation.childs,
          adultes: this.reservation.adultes,
          detail: this.reservation.comment,
          total: this.total,
        };
        this.addReservation({
          restaurant: restaurant_,
          data: newItem,
        })
          .then((res) => {
              this.$modal.hide("loading");
  
            if (res.status == 202) {
              this.error = true;
              this.showError = true;
              this.detail_table = -1;
               this.$modal.show("error");
  
        
            } else if (res.status == 200) {
  
            
               this.$modal.show("success");
  
              this.reservation = {
                nom: "",
                prenom: "",
                time: "",
                duree: "",
                enfants: "",
                adultes: "",
                comment: "",
              };
              
            }
          })
          .catch((err) => {
            console.log(err);
          });
        
      },
      moneticoPayment() {
      //   let menu_items = [];
      //   let payment = "";
      //   let type = "web";
      //   if (this.configuration.selectedMediaCreditCard) {
      //     payment = this.configuration.selectedMediaCreditCard.ObjectNumber._text;
      //   }
      //   if (this.configuration.selectedTypeCommande) {
      //     type = this.configuration.selectedTypeCommande.OrdTypeID._text;
      //   }



      //   this.generatePaymentData({
      //     data,
      //     callback: (res) => {
      //       if (res.ok === false) {
      //         this.$modal.show("error");
      //       } else {
      //         this.$refs.payment_form.submit();
      //         // this.$modal.show('success')
      //         // this.downloadFile(res);
      //       }
      //     },
      //   });
    },



  },

  mounted() {
    console.log("this.$socket");
    console.log(this.$socket);
    this.$modal.show("payment");
    let prams = window.location.href.split("?")[0].split("/");
    let pas = 0;
    let table = null;


    let restaurant_ = prams[prams.length - (pas + 1)];
    this.params = {
      restaurant: restaurant_,
      menu: null,
      table: table,
    };
    this.getConfiguration(restaurant_);
    // this.checkClient(restaurant_);

    // let dateChecked = new Date().toISOString().split("T")[0];
    //       let heure =  moment().format("HH:mm");
    //       let data = this.getTablesDispos({
    //         slug: this.$route.params.restaurant,
    //         date: dateChecked,
    //         heure: heure,
    //         rvc: this.rvc.value,
    //     });



    const urlParams = new URLSearchParams(window.location.search);


    let ammount = 15;
    if (urlParams.get('valprep')) {
      ammount = urlParams.get('valprep') * 1
    }
    this.options = {
      // environment: 'PRODUCTION',
      environment: "TEST",
      buttonColor: "white",
      allowedCardNetworks: [
        "AMEX",
        "DISCOVER",
        "INTERAC",
        "JCB",
        "MASTERCARD",
        "VISA",
      ],
      allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
      merchantInfo: {
        merchantName: this.restaurant.googlepay.merchantName,
        merchantId: this.restaurant.googlepay.merchantId,
        // merchantName: "Ihospitality",
        // merchantId: "BCR2DN4TZCGNJMLG",
      },
      transactionInfo: {
        totalPriceStatus: "FINAL",
        totalPrice: `${parseFloat(ammount).toFixed(2)}`,
        currencyCode: "EUR",
        countryCode: "FR",
      },
    };
    this.$modal.show("payment");

  },
  created() {
    // this.$ws.$on(`START_ORDER`, (d) => {});
  },
};
</script>
  
<style >
#audio {
  /* opacity: 0;
    width: 1px;
    height: 1px;
    overflow: hidden; */
}

.hiden_audio {
  /* width: 0.5px;
    height: 0.5px; */
  /* opacity: 0; */
  /* overflow: hidden; */
  display: block;
}

.payment_icon {
  width: 30px;
}

.paypal_payment_icon {
  width: 87px !important;
  object-fit: contain !important;
  position: relative;
  top: 22px;
}

.paymement_button {
  border-radius: 5px !important;
  background: #fff !important;
  color: #264740 !important;
  display: flex;
  justify-content: space-between;
}

.paymement_button img {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.paymement_button.card {
  background-color: #0b6eaf;
}

.paymement_button.cash {
  background-color: #a9d696;
}

.hidden {
  height: 0px;
  width: 0px;
  overflow: hidden;
}

.paypal_button {
  background-color: #ffc439 !important;
  padding: 0px !important;
  position: relative;
  height: 80px;
}

.client_form_conainer {
  padding: 12px;
}

.modal_title {
  display: block;
  padding: 16px 12px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  /* letter-spacing: 1.5px; */
  background: #1baaae;
  background: black;
  /* color: #37474f; */
  width: 100%;
  text-align: center;
}

.remove {
  color: #ff8080;
}

.infos_td {
  text-align: left;
}

.full {
  width: 100%;
  flex: 1;
  margin-bottom: 80px;
}

.full.center {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.modal_content {
  width: 100%;
  height: 100svh;
  max-height: 100vh;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 0px;
  padding-top: 0px;
}

.close_modal {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 12px;
  color: #37474f;
  color: #fff;
}

.vm--container {
  z-index: 999999;
}

.vm--modal {
  width: 100% !important;
  min-height: 100svh;
  top: 0px !important;
  left: 0px !important;
}

.bottom_commande {
  position: fixed;
  bottom: 0px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  left: 0px;
  /* display: none; */
}

.bottom_content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 24px;
  background: transparent !important;
}

.bottom_content_box {
  background: #264740;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-radius: 50px;
  position: relative;
  bottom: 6px;
}

.bottom_content span {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.bottom_content i {
  color: #fff;
}

.table-image thead td,
.table-image thead th {
  border: 0;
  color: #666;
  font-size: 0.8rem;
}

.table-image thead td,
.table-image thead th {
  vertical-align: middle;
  text-align: center;
}

.qty {
  max-width: 2rem;
}

.price {
  margin-left: 1rem;
}

.modal-footer {
  padding-top: 0rem;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  /* height: 100%; */
  width: 100%;
  max-width: 773px;
  left: 22px;
  border-radius: 0px;
}

.close {
  font-size: 22px;
}

@media (min-width: 576px) {
  .vm--container {
    max-width: 100%;
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .vm--container {
    max-width: 720px;
    margin-left: calc((100% - 720px) / 2);
  }
}

@media (min-width: 992px) {
  .vm--container {
    max-width: 960px;
    margin-left: calc((100% - 960px) / 2);
  }
}

@media (min-width: 1200px) {
  .vm--container {
    max-width: 1140px;
    margin-left: calc((100% - 1140px) / 2);
  }

  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
    padding: 0px !important;
  }
}

@media (min-width: 1400px) {
  .vm--container {
    max-width: 1320px;
    margin-left: calc((100% - 1320px) / 2);
  }
}

/* @media only screen and (min-width: 1000px) {
  
  
  .vm--container{
        max-width: 780px;
      margin-left: calc((100% - 780px)/2);
  }
  
  } */
@media only screen and (max-width: 500px) {
  .addTo {
    top: 50px;
  }

  .ajouter {
    right: 50px !important;
    top: -16px !important;
    font-size: 10px !important;
  }

  .price {
    font-size: 12px;
    margin-left: 16px;
    font-weight: 500;
    min-width: unset;
    display: block;
    position: relative;
    right: 0px !important;
    text-align: right;
  }
}

@media only screen and (max-width: 800px) {
  .category_title {
    position: relative;
    width: calc(100% - 20px);
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 6px solid black;
    margin-bottom: 24px;
    display: block;
    padding-bottom: 12px;
  }

  .price {
    left: 12px;
  }

  .addTo {
    top: 49px !important;
    right: 11px !important;
    font-size: 12px !important;
  }

  /* .item {
      display: flex;
      width: calc(100% - 26px) !important;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 24px;
      border-bottom: 1px solid #8080801c;
      padding-bottom: 12px;
  
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
  } */

  .ajouter {
    font-size: 10px !important;
    right: 160px;
    top: 1px;
  }

  .price {
    font-size: 12px;
    margin-left: 16px;
    font-weight: 500;
    /* min-width: 80px; */
    display: block;
    position: relative;
    right: 0px !important;
    text-align: right;
  }

  .header,
  .body,
  .footer {
    width: 100%;
  }

  .subcategory_title {
    width: calc(100% - 0px) !important;
    right: 0px;
  }

  .category_title {
    width: calc(100% - 0px) !important;
    color: #fff;
    background: black;
    font-size: 16px !important;
    padding: 6px 12px !important;
  }

  .azour_body .category {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .azour_body .collapsed {
    right: 12px !important;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: unset;
    border-radius: 0.3rem;
    outline: 0;
    /* height: 100%; */
    width: 100%;
    max-width: 756px;
    left: 0px;
    border-radius: 0px;
    min-height: 100%;
  }

  .modal {
    left: 0px;
    top: 0px;
    padding: 0px !important;
    height: 100%;
  }

  .modal.show .modal-dialog {
    width: 100%;
    margin: 0px;
    height: 100%;
  }

  .modal-title {
    font-size: 14px;
    text-transform: uppercase;
  }

  td {
    font-size: 12px;
    font-weight: normal;
  }

  th {
    font-size: 12px;
    font-weight: bold;
  }

  .text-left {
    text-align: left !important;
  }
}

.quantity {
  display: flex;
  justify-content: center;
  align-items: center;
}

.controls_container {
  vertical-align: middle !important;
}

span.quantity_value {
  font-size: 14px;
  margin: 0px 9px;
  color: #000;
  flex: 1;
}

span.plus {
  background: #1baaae !important;
}

span.plus,
span.minus {
  background: #1baaae;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 50%;
  vertical-align: middle;
  font-size: 7px;
  opacity: 0.9;
}

span.plus,
span.minus {
  background: #1baaae;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 3px;
  border-radius: 0px;
  vertical-align: middle;
  font-size: 7px;
  opacity: 0.9;
}

td {
  vertical-align: middle;
}

.remove {
  font-size: 18px !important;
  padding-right: 0px !important;
  text-align: right !important;
  width: 25px !important;
}

.bottom_commande_cart_half {
  flex-direction: column;
  justify-content: center;
  padding: 14px !important;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding-bottom: 24px;
}

.bottom_commande_cart {
  flex-direction: column;
  justify-content: center;
  padding: 14px !important;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
  padding-bottom: 24px;
}

.modal_buttons {
  flex-direction: row;
  justify-content: space-between;
  padding: 14px !important;
  align-items: center;
  position: relative;
  /* position: absolute; */
  bottom: 0px;
  width: 100%;
  background: transparent !important;
}

#button_commander {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  margin-bottom: 12px;
  border-radius: 50px;
}

.button_commander_half {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  margin-bottom: 12px;
  border-radius: 10px;
}

.button_commander {
  padding: 6px 12px;
  flex: 1;
  justify-content: flex-start;
  text-align: left;
}

.total {
  padding: 6px 12px;
}

.showAllBill {
  padding: 6px 12px;
  flex: 1;
  justify-content: center;
  text-align: center;
  width: calc(100% - 24px);
  background: #f05d2e;
}

#showAllBill {
  width: calc(100% - 24px);
  background: #f05d2e;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 12px;
  border-radius: 50px;
  overflow: hidden;
}

#showAllBill1 .showAllBill {
  color: #f05d2e !important;
  text-decoration: underline !important;
  padding: 0px !important;
  background: transparent !important;
}

#showAllBill1 {
  width: calc(100% - 24px);
  background: transparent;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 12px;
  border-radius: 50px;
  overflow: hidden;
}

.modal-header {
  background: #f05d2e;
  color: white;
  border-radius: 0px;
}

/* .modal.fade:not(.in).right .modal-dialog {
      -webkit-transform: translate3d(25%, 0, 0);
      transform: translate3d(25%, 0, 0);
  } */

#payemnt_back {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  /* padding: 12px; */
  text-align: center;
  display: flex;
  justify-content: flex-start;
  margin: 0px;
  align-items: center;
  padding-left: 20px;
  font-size: 12px;
}

.modal_button {
  flex: 1;
  background: #f05d2e;
  color: #fff;
  /* padding: 12px; */
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0px 6px;
  align-items: center;
  padding: 12px;
  font-size: 12px;
  margin-top: 12px;
}

.modal_buttons {
  display: flex;
}

.paymement_buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 12px;
  padding-bottom: 150px;
}

.google_pay {
  padding: 16px !important;
}

.paymement_button {
  width: 100%;
  color: #fff;
  padding: 22px;
  margin: 6px 0px;
  flex-direction: row;
  display: flex;
  align-items: center;
  /* margin: 0px 6px; */
  font-size: 12px;
}

.modal_button_text {}

.client-form {
  margin-bottom: 18px;
  font-size: 12px;
  text-align: left;
}

.client-form label {
  margin-bottom: 3px;
}

input {
  font-size: 12px !important;
}

.center_content {
  justify-content: center;
  align-items: center;
  display: flex;
}

.success_message img {
  width: 60%;
  margin-bottom: 20px;
}

.error_img {
  width: 80% !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

@media only screen and (min-width: 1000px) {
  .error_img {
    width: 60% !important;
    margin-bottom: 20px !important;
    position: relative;
    bottom: 40px;
  }

  .success_message img {
    width: 30%;
    margin-bottom: 20px;
  }
}

.loading_img {
  width: 120px !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

.expire_img {
  width: 180px !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

.success_message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  text-align: center;
  font-size: 14px;
  padding-bottom: 60px;
}

.pending_message {
  position: relative;
  bottom: 40px;
}

.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: unset;
  outline: 0;
  box-shadow: unset;
}

.form-control {
  border-radius: 0px;
}

.loader {
  display: none;
  width: 100%;
  height: 100%;
}

.loader .loader_container {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 50%;
  justify-content: center;
  align-items: center;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #000;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

/* Variables */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

/* form {
    width: 30vw;
    min-width: 500px;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
      0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 40px;
  } */

input {
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  font-size: 16px;
  width: 100%;
  background: white;
}

.result-message {
  line-height: 22px;
  font-size: 16px;
}

.result-message a {
  color: rgb(89, 111, 214);
  font-weight: 600;
  text-decoration: none;
}

.hidden {
  display: none;
}

#card-error {
  color: rgb(105, 115, 134);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}

#payment-request-button {
  margin-bottom: 32px;
}

/* Buttons and links */
button {
  background: #5469d4;
  color: #ffffff;
  font-family: Arial, sans-serif;
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}

button:hover {
  filter: contrast(115%);
}

button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}

.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}

.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}

.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  /* form {
      width: 80vw;
    } */
}

/* .card_monetico {
    border-radius: 5px;
    background: linear-gradient(68deg, #f28e09eb, #4c3040c9) !important;
  }
  
  .bitcoin_card {
    border-radius: 5px;
    background: linear-gradient(68deg, #f28e09eb, #f28e09eb) !important;
  } */

#payment_form {
  width: 0.5px;
  height: 0.5px;
  opacity: 0;
  visibility: hidden;
}

@media only screen and (min-width: 800px) {

  /* .vm--modal {
      width: 88% !important;
      min-height: 100vh;
      top: 0px !important;
      left: 6% !important;
    } */
    span.plus,
    span.minus {
      background: black;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0px;
      border-radius: 0px;
      vertical-align: middle;
      font-size: 7px;
      opacity: 0.9;
      border-radius: 3px;
    }
  }
  
  .modal-footer {
    background: #fff;
  }
  .modal_content {
    overflow: overlay;
  }
  
  form#payment-form {
    margin-top: 12px;
    /* padding: 16px 56px; */
  }
  
  .modal_down::after {
    content: " ";
    display: block;
    width: 35px;
    height: 35px;
    background: transparent;
    position: absolute;
    top: 12px;
    right: 12px;
    background-image: url("https://space.monresto.menu/new_images/close.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    z-index: 99;
  }
  
  .orange_text {
    color: #f05d2e;
  }
  input.pin_input {
    margin-top: 12px;
  }
  .pin_input {
    width: 70% !important;
    border-radius: 50px !important;
    margin: auto;
    text-align: center !important;
  }
  .pin_box {
    width: 100%;
    padding-top: 12px !important;
  }
  .error_pin {
    text-align: center;
    color: #f05d2e !important;
    font-size: 12px !important;
  }
  </style>
  